import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import useTranslation from 'next-translate/useTranslation';

const FirstPlayGuide = ({ onClose }: { onClose: () => void }) => {
  const { t } = useTranslation();
  useEffect(() => {
    window.addEventListener('keypress', (e: KeyboardEvent) => {
      e.code === 'Space' && onClose();
    });
    return () => {
      window.removeEventListener('keypress', (e: KeyboardEvent) => {
        e.code === 'Space' && onClose();
      });
    };
  }, []);

  return (
    <Container
      onClick={() => {
        onClose();
      }}
    >
      <div className="bg"></div>
      <div className="text no-select">
        <div>{t('chat_screen_description_tab_the_screen_or_space_bar')}</div>
        <br></br>
        <div>{t('chat_screen_description_if_you_scroll')}</div>
        <div>{t('chat_screen_description_auto_play_is_displayed')}</div>
      </div>
    </Container>
  );
};

const Container = styled.div`
  height: 100%;
  width: 100%;

  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .bg {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    opacity: 0.6;
    background-color: black;
  }

  .text {
    height: 100%;
    position: relative;
    font-family: Abhaya Libre SemiBold;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    letter-spacing: -0.4px;
    color: ${({ theme }) => theme.colors.white};

    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`;

export default FirstPlayGuide;
